import React, { Component } from 'react'
import ScrollToTop from '../../../components/ScrollToTop'
import MenuSider from '../../../components/MenuSider'
import { connect } from 'react-redux'
import IntlMessages from '../../../util/IntlMessages';
import { Carousel } from 'antd';
import 'antd/dist/antd.css';
//import 'bootstrap/dist/css/bootstrap.css';
import './Companyadmin.css';


class CompanyAdmin extends Component {



    render() {
        return (
            <div>
                <ScrollToTop />
                <MenuSider title={<IntlMessages id="companyadmin.title" />}>
                    <div className="content">
                        <Carousel>
                            <div><h3><img src="/images/companyadmin/Slide01.jpg" alt='Slide01' width="100%"></img></h3></div>
                            <div><h3><img src="/images/companyadmin/Slide02.jpg" alt='Slide02' width="100%"></img></h3></div>
                            <div><h3><img src="/images/companyadmin/Slide03.jpg" alt='Slide03' width="100%"></img></h3></div>
                            <div><h3><img src="/images/companyadmin/Slide04.jpg" alt='Slide04' width="100%"></img></h3></div>
                            <div><h3><img src="/images/companyadmin/Slide05.jpg" alt='Slide05' width="100%"></img></h3></div>
                            <div><h3><img src="/images/companyadmin/Slide06.jpg" alt='Slide06' width="100%"></img></h3></div>
                            <div><h3><img src="/images/companyadmin/Slide07.jpg" alt='Slide07' width="100%"></img></h3></div>
                            <div><h3><img src="/images/companyadmin/Slide08.jpg" alt='Slide08' width="100%"></img></h3></div>
                            <div><h3><img src="/images/companyadmin/Slide09.jpg" alt='Slide09' width="100%"></img></h3></div>
                            <div><h3><img src="/images/companyadmin/Slide10.jpg" alt='Slide10' width="100%"></img></h3></div>
                            <div><h3><img src="/images/companyadmin/Slide11.jpg" alt='Slide11' width="100%"></img></h3></div>
                        </Carousel>

                    </div>
                </MenuSider>
            </div>
        );
    }
}
const mapStatetoProps = (state) => {
    return {
        detail: state.detail,
        authen: state.authen,
        detailMyOb: state.detailMyOb,
    }
}

export default connect(mapStatetoProps)(CompanyAdmin)